import Header from "./header";
import Footer from "./footer";
import React, {useContext} from "react";
import {BrowserRouter as Router, Route, Routes, Navigate} from "react-router-dom";
import Quotes from "../quote/quotes";
import Konva from "../konva-examples/konva";
import AddQuoteDetails from "../quote/add-quote-details";
import QuoteDesigner from "../quote-designer/quote-designer";
import AppContext from "../common/context/app-context";
import Tags from "../tag/tags";
import AddTagDetails from "../tag/add-tag-details";
import Images from "../image/images";
import ImageUpload from "../image/image-upload";
import Pods from "../pod/components/pods";
import AddPodDetails from "../pod/components/add-pod/add-pod-details";
import EditPodDetails from "../pod/components/edit-pod/edit-pod-details";
import Designer from "../designer/designer";
import Designs from "../design/components/designs";
import DesignEditor from "../design/components/design-editor/design-editor";
import AddEditDesign from "../design/components/add-design/add-edit-design";
import Themes from "../theme/components/themes";
import AddThemeDetails from "../theme/components/add-theme-details";
import PublisherDashboard from "../design/components/publisher/publisher-dashboard";
import AddMultipleDesigns from "../design/components/add-design/add-multiple-designs";
import EditMultipleImagesDashboard from "../image/edit-multiple-images/edit-multiple-images-dashboard";
import ShopifyDashboard from "../shopify/components/dashboard/shopify-dashboard";
import MultiProductsDesignerDashboard
    from "../design/components/multi-products-designer/multi-products-designer-dashboard";
import MarketingDashboard from "../marketing/components/dashboard/marketing-dashboard";
import ContentDashboard from "../content/components/dashboard/content-dashboard";
import DesignBlogPostDashboard from "../content/components/blog-post/design-blog-post-dashboard";
import UtilitiesDashboard from "../utilities/components/utilities-dashboard";
import PrintfulDashboard from "../printful/components/printful-dashboard";
import MasterDataDashboard from "../master-data/components/master-data-dashboard";
import FacebookDashboard from "../facebook/components/facebook/facebook-dashboard";
import DesignCampaign from "../facebook/components/campaign/design-campaign";
import ShowNoAccessMessage from "../security/components/show-no-access-message";
import LoginDetail from "../security/components/login-detail";
import PinterestDashboard from "../pinterest/components/pinterest/pinterest-dashboard";
import GoogleWebFontLoader from "../common/fonts/google-web-font-loader";

const Layout = () => {
    const appContext = useContext(AppContext);
    let {isAuthenticated} = appContext;

    return (
        <>
            <Header/>

            <Router>
                <Routes>
                    <Route path="/"
                           element={!isAuthenticated ? <Navigate to="/login"/> : <Navigate to="/designs"/>}></Route>
                    <Route path='/login' element={<LoginDetail/>}></Route>
                    <Route path='/no-access' element={<ShowNoAccessMessage/>}></Route>
                    <Route path='/quotes' element={<Quotes/>}></Route>
                    <Route path='/quotes/add-quotes' element={<AddQuoteDetails/>}></Route>
                    <Route path='/quotes/:quoteId/designs' element={<QuoteDesigner/>}></Route>
                    <Route path='/tags' element={<Tags/>}></Route>
                    <Route path='/tags/add-tags' element={<AddTagDetails/>}></Route>
                    <Route path='/images' element={<Images/>}></Route>
                    <Route path='/images/upload-images' element={<ImageUpload/>}></Route>
                    <Route path='/images/edit-multiple-images' element={<EditMultipleImagesDashboard/>}></Route>
                    <Route path='/pods' element={<Pods/>}></Route>
                    <Route path='/pods/add-pods' element={<AddPodDetails/>}></Route>
                    <Route path='/pods/:podId/edit' element={<EditPodDetails/>}></Route>
                    <Route path='/designs' element={<Designs/>}></Route>
                    <Route path='/designs/add' element={<AddMultipleDesigns/>}></Route>
                    <Route path='/designs/multi-products-designer' element={<MultiProductsDesignerDashboard/>}></Route>
                    <Route path='/designs/:designId/edit' element={<AddEditDesign/>}></Route>
                    <Route path='/designs/:designId/design' element={<DesignEditor/>}></Route>
                    <Route path='/designs/:designId/publish' element={<PublisherDashboard/>}></Route>
                    <Route path='/themes' element={<Themes/>}></Route>
                    <Route path='/themes/add-themes' element={<AddThemeDetails/>}></Route>
                    <Route path='/konva' element={<Konva/>}></Route>
                    <Route path='/shopify' element={<ShopifyDashboard/>}></Route>
                    <Route path='/marketing' element={<MarketingDashboard/>}></Route>
                    <Route path='/content' element={<ContentDashboard/>}></Route>
                    <Route path='/content/blog-post/:blogPostId' element={<DesignBlogPostDashboard/>}></Route>
                    <Route path='/utilities' element={<UtilitiesDashboard/>}></Route>
                    <Route path='/printful' element={<PrintfulDashboard/>}></Route>
                    <Route path='/pinterest' element={<PinterestDashboard/>}></Route>
                    <Route path='/facebook' element={<FacebookDashboard/>}></Route>
                    <Route path='/facebook/campaigns/:campaignId/design' element={<DesignCampaign/>}></Route>
                    <Route path='/master-data' element={<MasterDataDashboard/>}></Route>
                </Routes>
            </Router>

            <Footer/>
        </>
    );
}


export default Layout;
